import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DropdownIcon12 = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    d='M7 10L12 15L17 10'
    stroke={props.color ?? 'white'}
    strokeWidth='1.5'
    strokeMiterlimit='10'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default DropdownIcon12;
